import {
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
} from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { useEffect, useState } from 'react';
import { Promotion, PromotionDetail } from '../data';
import { promotionServices } from '../restaurant-promotions/services';
import { Moment } from 'moment';
import ConditionsSetting from './ConditionsSetting';
import moment from 'moment';
import { useAppSelector } from '../../../store';
import { LoadingIcon } from '@you-go-vn/components';
import { promotionDiscountTargets, promotionDiscountTypes } from '..';

type Props = {
  visible: boolean;
  title: string;
  onFinish: (values: PromotionDetail) => Promise<{
    success?: boolean;
    errors?: { field: string; errors: string[] }[];
  }>;
  onCancel: () => void;
  initValues?: Promotion;
};
const ModalFormPromotion = ({
  visible,
  title,
  initValues,
  onFinish,
  onCancel,
}: Props) => {
  const { currentRestaurant } = useAppSelector((s) => s.restaurant);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<PromotionDetail>();

  useEffect(() => {
    if (visible && initValues?.id) {
      setLoading(true);
      promotionServices
        .getById(currentRestaurant?.id, initValues.id)
        .then(({ data }) => {
          setData(data.data);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [visible, initValues, currentRestaurant]);

  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [discountType, setDiscountType] = useState<
    'fixed_amount' | 'percentage_amount'
  >('fixed_amount');

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({
      ...data,
      time: [moment(data?.startsFrom), moment(data?.endTill)],
    });
  }, [data, form]);

  return (
    <Modal
      width={777}
      centered
      destroyOnClose
      forceRender
      title={title}
      visible={visible}
      confirmLoading={isSubmitting}
      onOk={() => form.submit()}
      onCancel={() => {
        onCancel();
      }}
    >
      {loading ? (
        <LoadingIcon />
      ) : (
        <Form
          name="add"
          form={form}
          layout="vertical"
          colon={false}
          scrollToFirstError
          onFinish={async (values) => {
            if (onFinish) {
              setIsSubmitting(true);
              values['startsFrom'] = values.time
                ? (values.time[0] as Moment).utc().format()
                : undefined;
              values['endTill'] = values.time
                ? (values.time[1] as Moment).utc().format()
                : undefined;
              delete values['time'];
              const res = await onFinish(values);
              if (res.success && !initValues) form.resetFields();
              if (res.errors) {
                const arr = res.errors.map((x) => {
                  if (x.field === 'startsFrom' || x.field === 'endTill') {
                    const es = [];
                    const startsFromErrors = res.errors?.find(
                      (x) => x.field === 'startsFrom',
                    )?.errors;
                    if (startsFromErrors) es.push(...startsFromErrors);
                    const endTillErrors = res.errors?.find(
                      (x) => x.field === 'endTill',
                    )?.errors;
                    if (endTillErrors) es.push(...endTillErrors);
                    return {
                      name: 'time',
                      errors: es,
                    };
                  }
                  return {
                    name: x.field,
                    errors: x.errors,
                  };
                });
                form.setFields(arr);
                form.scrollToField(res.errors[0].field);
              }
              setIsSubmitting(false);
            }
          }}
          validateTrigger="onSubmit"
          onFieldsChange={(changedFields) => {
            changedFields.map((x) => {
              if (!Array.isArray(x.name)) return '';

              if (x.name[0] === 'discountType') {
                setDiscountType(x.value);
              }
              if (x.name[0] === 'percentageYougo') {
                form.setFieldsValue({ percentageMerchant: 100 - x.value });
              }
              if (x.name[0] === 'percentageMerchant') {
                form.setFieldsValue({ percentageYougo: 100 - x.value });
              }

              return '';
            });
          }}
        >
          <Form.Item name="id" label="ID" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="code" label="Mã khuyến mãi" required>
            <Input
              placeholder="Nhập Mã khuyến mãi"
              // addonAfter={
              //   <Form.Item
              //     noStyle
              //     name="type"
              //     rules={[{ required: true }]}
              //     initialValue={Object.keys(typePromotionMap)[0]}
              //   >
              //     <Select>
              //       {Object.keys(typePromotionMap).map((x) => {
              //         const d = typePromotionMap[x];
              //         return (
              //           <Select.Option key={x} values={x}>
              //             {d}
              //           </Select.Option>
              //         );
              //       })}
              //     </Select>
              //   </Form.Item>
              // }
            />
          </Form.Item>
          <Form.Item name="name" label="Tên" required>
            <Input placeholder="Nhập Tên" />
          </Form.Item>
          <Form.Item name="description" label="Mô tả" required>
            <Input.TextArea placeholder="Nhập Mô tả" />
          </Form.Item>
          <Form.Item name="time" label="Thời gian bắt đầu và kết thúc" required>
            <DatePicker.RangePicker format="LL" style={{ width: '100%' }} />
          </Form.Item>

          <Row gutter={16}>
            <Col md={8} sm={24}>
              <Form.Item
                name="discountAmount"
                label="Giá trị được giảm"
                initialValue={0}
                required
              >
                <InputNumber
                  placeholder="Nhập Giá trị được giảm"
                  {...(discountType === 'fixed_amount'
                    ? {
                        formatter: (value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        parser: (value) =>
                          parseInt(value?.replace(/\$\s?|(,*)/g, '') || '0'),
                      }
                    : {
                        max: 100,
                      })}
                  addonAfter={
                    <Form.Item
                      name="discountType"
                      noStyle
                      initialValue={promotionDiscountTypes[0].value}
                    >
                      <Select>
                        {promotionDiscountTypes.map((x) => {
                          return (
                            <Select.Option key={x.value} values={x.value}>
                              {x.label}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  }
                />
              </Form.Item>
            </Col>
            <Col md={8} sm={24}>
              <Form.Item
                name="discountMax"
                label="Giá trị giảm tối đa"
                initialValue={0}
                required
              >
                <InputNumber
                  placeholder="Nhập Số tiền tối đa được giảm"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, '') || 0}
                  addonAfter="VNĐ"
                />
              </Form.Item>
            </Col>
            <Col md={8} sm={24}>
              <Form.Item
                name="discountTarget"
                label="Giảm vào"
                initialValue={promotionDiscountTargets[0].value}
                required
              >
                <Radio.Group>
                  {promotionDiscountTargets.map((x) => {
                    return (
                      <Radio key={x.value} value={x.value}>
                        {x.label}
                      </Radio>
                    );
                  })}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col md={12} sm={24}>
              <Form.Item
                // noStyle
                label="YouGo chi trả"
                name="percentageYougo"
                initialValue={50}
                required
              >
                <InputNumber
                  placeholder="Nhập phần trăm tiền"
                  min={0}
                  max={100}
                  addonAfter="%"
                />
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item
                name="percentageMerchant"
                label="Đối tác chi trả"
                initialValue={50}
                required
              >
                <InputNumber
                  placeholder="Nhập phần trăm tiền"
                  min={0}
                  max={100}
                  addonAfter="%"
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="numberCanCombined"
            label="Số lượng mã giảm giá có thể dùng chung"
            initialValue={0}
            required
          >
            <InputNumber
              placeholder="Nhập Số lượng mã giảm giá có thể dùng chung"
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            name="limitUsesPerCode"
            label="Giới hạn số lần sử dụng"
            initialValue={0}
            required
          >
            <InputNumber
              placeholder="Nhập Giới hạn số lần sử dụng"
              formatter={(value) => `${value}`.replace(/^0$/, '∞')}
              parser={(value) => value?.replace(/∞/g, '') || 0}
            />
          </Form.Item>
          <Form.Item
            name="limitUsesPerCodeInDate"
            label="Giới hạn số lần sử dụng trong ngày"
            initialValue={0}
            required
          >
            <InputNumber
              placeholder="Nhập Giới hạn số lần sử dụng trong ngày"
              formatter={(value) => `${value}`.replace(/^0$/, '∞')}
              parser={(value) => value?.replace(/∞/g, '') || 0}
            />
          </Form.Item>
          <Form.Item
            name="limitUsesPerUser"
            label="Giới hạn số lần sử dụng của mỗi khách hàng"
            initialValue={0}
            required
          >
            <InputNumber
              placeholder="Nhập Giới hạn số lần sử dụng của mỗi khách hàng"
              formatter={(value) => `${value}`.replace(/^0$/, '∞')}
              parser={(value) => value?.replace(/∞/g, '') || 0}
            />
          </Form.Item>
          <Form.Item
            name="limitUsesPerUserInDate"
            label="Giới hạn số lần sử dụng của mỗi khách hàng trong ngày"
            initialValue={0}
            required
          >
            <InputNumber
              placeholder="Nhập Giới hạn số lần sử dụng của mỗi khách hàng trong ngày"
              formatter={(value) => `${value}`.replace(/^0$/, '∞')}
              parser={(value) => value?.replace(/∞/g, '') || 0}
            />
          </Form.Item>
          <Form.Item
            name="onlyInPromotion"
            valuePropName="checked"
            initialValue={true}
            required
          >
            <Checkbox>
              Chỉ dùng trong những nhà hàng có chương trình khuyến mãi
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="canJoinPromotion"
            valuePropName="checked"
            initialValue={true}
            required
          >
            <Checkbox>
              Cho phép nhà hàng tham gia chương trình khuyến mãi
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="isPublic"
            valuePropName="checked"
            initialValue={true}
            required
          >
            <Checkbox>Gợi ý cho mã giảm giá</Checkbox>
          </Form.Item>
          <Form.Item
            name="isActive"
            valuePropName="checked"
            initialValue={true}
            required
          >
            <Checkbox>
              Trạng thái (Có thể sử dụng || Không thể sử dụng)
            </Checkbox>
          </Form.Item>

          <ConditionsSetting form={form} />
        </Form>
      )}
    </Modal>
  );
};

export default ModalFormPromotion;
